import { Component, ViewContainerRef } from '@angular/core';
import { Router} from '@angular/router';
import { Notification } from '../../models/notification/notification.model';
import { NotificationService } from '../../services/notification/notification.service';
import { NotificationEvent } from '../../models/events/notification-event.model';
import { Role } from '../../models/shared/role.model';
import { UtilitiesService } from '../../services/shared/utilities.service';
import { NotificationRole } from '../../models/notification/notificationRole.model';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { RolePermissionService } from '../../services/role/role-permission.service';

@Component({
  selector: 'app-notification-list',
  templateUrl: './notification-list.component.html',
  styleUrls: ['./notification-list.component.css']
})
/** notification-list component*/
export class NotificationListComponent {
  public notificationList: Notification[];
  public pagenumber: number = 0;
  public rowsPerPage: number = 10;
  public totalRecord: number = 0;
  public customerTypes: Role[];
  public notificationEvents: NotificationEvent[] = [];
  public notificationTypes: string[];
  public searchKeyword: string="";
  public isActive: string = "";
  public notificationEventID: number = 0;
  //Filter items from grid
  //filteredItems: any[];
 // public rowsOnPage: number = 10;;
  public arrRowsPerPage: number[];
  public notificationRoles: NotificationRole[];
  public role: Role;
  public isDeleteAllowed: boolean = false;
  public isEditAllowed: boolean = false;
  public isCreateAllowed: boolean = false;
  public showBoundaryLinks: boolean = true;
  
  /** notification-list ctor */
  constructor(private readonly notificationService: NotificationService,
    private readonly utilitiesService: UtilitiesService,
    private readonly toastr: ToastsManager, vcr: ViewContainerRef, private readonly rolePermissionService: RolePermissionService, private readonly router: Router) {
    this.rolePermissionService.GetRolePermissions("notification").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });
          var list = data.filter(function (element) {
            return (element.action == "list");
          });

          var deletePermission = data.filter(function (element) {
            return (element.action == "delete");
          });

          var edit = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0)
            this.isCreateAllowed = true;

          if (edit.length > 0)
            this.isEditAllowed = true;

          if (deletePermission.length > 0)
            this.isDeleteAllowed = true;
          if (list.length > 0) {
          this.toastr.setRootViewContainerRef(vcr);
          this.GetNotifications();
          this.GetCustomerTypes();
          this.GetNotificationTypes();
          this.GetNotificationEvents();
            this.GetRowsPerPageList();
          }
          else {
            this.router.navigate(["/"]);
          }
        }
        else {
          this.router.navigate(["/"]);
        }
      }
    )
  }
  GetNotifications() {
    this.notificationList = [];
    if (this.rowsPerPage == undefined) this.rowsPerPage = 10;
    if (this.pagenumber == undefined) this.pagenumber = 0;
    this.notificationService.GetNotificationsGrid(this.pagenumber, this.rowsPerPage, this.notificationEventID, this.searchKeyword, this.isActive).subscribe(
      data => {
        //this.isLoaded = true;
        this.notificationList = data;
        if (this.notificationList != null && this.notificationList.length > 0)
          this.totalRecord = this.notificationList[0].totalRecords;
        else
          this.totalRecord = 0;

      }
    )
  }
  ifNotificationTypeExist(id:string)
  {
    return false;
  }
  ifNotificationEventExist(id:number)
  {
    return (this.notificationEvents.find(i => i.eventID == id) == undefined);
  }
  GetCustomerTypes() {
    this.notificationService.GetCustomerTypes().subscribe(
      data => {
        this.customerTypes = data;
      }
    )
  }
  GetNotificationTypes() {
    this.notificationService.GetNotificationTypes().subscribe(
      data => {
        this.notificationTypes = data;
      });
  }
  GetNotificationEvents() {
    this.notificationService.GetNotificationActiveEvents().subscribe(
      data => {
        this.notificationEvents = data;
      }
    )
  }
  PageChanged($event) {
    this.pagenumber = ($event.page) - 1;
    this.rowsPerPage = $event.itemsPerPage;
    this.GetNotifications();
  }
  OnFilterChange() {
    this.pagenumber = 0;
    this.GetNotifications();
  }
  deleteNotification(id) {
    var ans = confirm("Are you sure to delete this notification ");
    if (ans) {
      this.notificationService.DeleteNotification(id);
      this.toastr.success('Notification deleted successfully.', 'Success');
      setTimeout(() => {
        this.GetNotifications();
      }, 2000);
    }
  }
  // Populate the row per page list
  GetRowsPerPageList() {
    this.arrRowsPerPage = this.utilitiesService.GetRowsPerPageList();
    this.rowsPerPage = this.arrRowsPerPage[0];
  }
  OnFilterChangegrid() {
    this.notificationList = [];
    if (this.rowsPerPage == undefined) this.rowsPerPage = 10;
    if (this.pagenumber == undefined) this.pagenumber = 0;
    this.notificationService.GetNotificationsGrid(this.pagenumber, this.rowsPerPage, this.notificationEventID, this.searchKeyword, this.isActive).subscribe(
      data => {
        //this.isLoaded = true;
        this.notificationList = data;
        if (this.notificationList != null && this.notificationList.length > 0)
          this.totalRecord = this.notificationList[0].totalRecords;
        else
          this.totalRecord = 0;

      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/notification-components/notification-list/notification-list.component.ts